// gd-gelstack-diagram.js — scroll-linked label reveal for Gelstack 6-layer diagram.
// Matches Bolt home/TechnologyShowcase.tsx GelstackDiagram() behavior.
// Image fades in when diagram enters viewport (threshold 0.8 vh).
// Labels reveal 1-by-1 as scroll progresses from 0.6 vh → 0.05 vh (capped at label count).
(function () {
  'use strict';

  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.gdGsInit === '1') return;
    root.dataset.gdGsInit = '1';

    const labels = root.querySelectorAll('[data-gd-gelstack-label], [data-gd-gelstack-mobile-label]');
    const labelCount = root.querySelectorAll('[data-gd-gelstack-label]').length;
    let maxRevealed = 0;
    let imageVisible = false;

    if (prefersReduced) {
      root.classList.add('is-gd-gelstack-visible');
      labels.forEach((l) => l.classList.add('is-gd-gelstack-label-active'));
      return;
    }

    function onScroll() {
      const rect = root.getBoundingClientRect();
      const vh = window.innerHeight;

      if (!imageVisible && rect.top < vh * 0.8) {
        imageVisible = true;
        root.classList.add('is-gd-gelstack-visible');
      }

      const start = vh * 0.6;
      const end = vh * 0.05;
      if (rect.top < start) {
        const progress = (start - rect.top) / (start - end);
        const clamped = Math.max(0, Math.min(1, progress));
        const count = Math.min(Math.ceil(clamped * labelCount), labelCount);
        if (count > maxRevealed) {
          maxRevealed = count;
          labels.forEach((l) => {
            const n = parseInt(l.dataset.gdGelstackLabel || l.dataset.gdGelstackMobileLabel, 10);
            if (n < count) l.classList.add('is-gd-gelstack-label-active');
          });
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gd-gelstack-diagram]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
